import SwipeInterceptPanResponder from '../../SwipeInterceptPanResponder';

export default SwipeInterceptPanResponder;
